import { http } from 'utils'

// Opportunity mutation imports.
import { SET_OPPORTUNITIES } from 'vx/mutations'

// Opportunity state.
const state = {
  opportunities: []
}

// Opportunity state getters.
const getters = {}

// Opportunity actions.
const actions = {
  /**
   * Get all opportunities.
   *
   * @return Promise
   */
  getOpportunities ({ commit }, params = {}) {
    return http.get('opportunities/v2', { params })
      .then((response) => {
        commit(SET_OPPORTUNITIES, response.data)

        return response
      })
  }
}

// Opportunity state mutations.
const mutations = {
  [SET_OPPORTUNITIES] (state, opportunities) {
    state.opportunities = opportunities
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
